module.exports = __webpack_public_path__ + "static/media/icon-camera-w.020d0165.svg";